"use client";

import Link from "next/link";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { Home } from "lucide-react";

interface ProductBreadcrumbProps {
    activeLabel: string;
    activeSlug: string;
}

export default function ProductBreadcrumb({ activeLabel, activeSlug }: ProductBreadcrumbProps) {
    const { dictionary } = useDictionary();

    const isAll = activeSlug === "all";

    return (
        <div className="flex items-center gap-2 text-sm text-secondary-400 mt-4 mb-5">
            <Link href="/" className="hover:text-secondary-200 transition">
                <Home size={15} />
            </Link>

            <span className="text-secondary-300">/</span>

            <Link
                href="/shop/category/products/all"
                className="hover:text-secondary-200 transition"
            >
                {dictionary.ui.profile.all + " " + dictionary.nav.products}
            </Link>
            {!isAll && (
                <>
                    <span className="text-secondary-300">/</span>
                    <span className="text-secondary-100 font-medium">{activeLabel}</span>
                </>
            )}

        </div>
    );
}
